import { useCallback } from 'react';

export const useDataLayer = ({ event, eventType, buttonText }) => {
	return useCallback(
		({ value, ...other }) =>
			() => {
				window?.dataLayer &&
					window.dataLayer.push({
						event,
						...(eventType && { [eventType]: value }),
						...(buttonText && { button_text: buttonText }),
						...other,
					});
			},
		[event, eventType, buttonText],
	);
};
